import React from 'react';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { transactionsUtils } from 'app-components/flux/transactions';

import Box from '@mui/material/Box';

import MuiTagsField from 'components/QuickenControls/TagsField/TagsField';
import SymbolLookupField from 'components/SymbolLookupField';
import { useAppSelector } from 'hooks/redux';

import { investmentTransactionEditFormHooks } from 'components/Forms/InvestmentTransactionEditForm/investmentTransactionEditFormHooks';
import type { SymbolLookupItemWithContract, TagValue } from './types';
import { tagToId } from './utils';

export function SecurityAndTagsFields(): React.JSX.Element {
  const securitiesEnabled = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'securities'));
  const manager = investmentTransactionEditFormHooks.useManager();
  const selectedSecurity = investmentTransactionEditFormHooks.useSelector(({ state }) =>
    transactionsUtils.security(
      {
        amount: state.amount ?? 0,
        localSecurityId: state.localSecurityId,
        postedOn: state.postedOn ?? '',
        securityName: state.securityName,
        symbol: state.symbol,
      },
      undefined,
    ),
  );
  const securityName = investmentTransactionEditFormHooks.useField('securityName');
  const tags = investmentTransactionEditFormHooks.useField('tags');
  const tagObjects = investmentTransactionEditFormHooks.useSelector(({ state }) => state.tags);

  return (
    <Box display='flex' gap={2}>
      <SymbolLookupField
        id='symbol-lookup'
        label='Security'
        sx={{ width: 400 }}
        hideCreateOption={!securitiesEnabled}
        value={selectedSecurity}
        onSelected={(item: SymbolLookupItemWithContract) => manager.fireAction('selectSecurity', item)}
        error={securityName.error}
        helperText={securityName.helperText}
        onFocus={(event: React.FocusEvent<HTMLInputElement>) => event.target.select()}
        autoFocus
      />
      <MuiTagsField
        id='tags'
        value={tagObjects}
        onChange={(_event: React.SyntheticEvent, tagArray: TagValue[]) => tags.onValueChange(tagArray.map(tagToId))}
      />
    </Box>
  );
}
